import { useContext } from 'react';
import { AppInsightsContext } from 'contexts/AppInsightsContext';

export const useAppInsights = () => {
  const appInsightsContext = useContext(AppInsightsContext);

  return appInsightsContext;
};